import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'
import { NotifyService } from 'common/util/services/notify.service'
import { SubtitlesClipboardService } from 'media/services/subtitlesClipboard.service'

@Injectable({ providedIn: 'root' })
class AddToAssetOp extends BaseOperation {
  icon = 'far fa-plus'
  showInSelectionToolbar = true
  showInContextMenu = true
  showInAssetView = true
  supportsMultiple = true
  supportsBundles = true
  weight = 50

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
    private api: APIService,
    private mediaPermissions: MediaPermissionsService,
    private notify: NotifyService,
    private subtitlesClipboard: SubtitlesClipboardService,
  ) {
    super()
    this.label = this.translate.instant('Add to asset')
  }

  isVisibleForBundle (bundle, context) {
    return (
      bundle.mainfile &&
      this.mediaPermissions.getPermissionForBundle(bundle)?.showSubtitles &&
      !this.panel.active &&
      this.isEnabledForBundle(bundle, context) &&
      bundle?.asset?.type === 'subtitle'
    )
  }

  async runForBundle (bundle) {
    this.subtitlesClipboard.add(bundle.asset, bundle)
    this.notify.info(this.translate.instant('Added'))
  }
}

MediaOperationsService.register(AddToAssetOp)
